import { ChangeEvent, forwardRef, useCallback, useEffect } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  IconButton,
  styled,
} from "@mui/material";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { ModalContainer } from "../../../../../../common/components/modal_container";
import { AnexarDocumentosForm } from "../../../schemas/Projetos_cadastro/Anexar_Documentos";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { DocumentoLista } from "../../../../domain/models/documentos_lista";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import FormContainer from "../../../../../../common/components/form_container";
import { DefaultFormDownloadInput } from "../../../../../../common/components/default_form_download_input";

type Props = {
  open: boolean;
  saving: boolean;
  selectedDocumentos: DocumentoLista | null;
  hookForm: UseFormReturn<AnexarDocumentosForm>,
  onClose: () => void;
  onSubmit: (form: AnexarDocumentosForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
  handleDownload: (arquivoNome: string, arquivo: string) => void;
  handleArquivoDeleteOpenState: (limparArquivos: string | null, arquivo: string | null, openState: boolean) => void;
};

export const AnexarDocumentosModelContent = (
  { open, hookForm, onClose, saving, onSubmit, selectedDocumentos, onOpenChangeHistory, handleDownload, handleArquivoDeleteOpenState }: Props) => {

  useEffect(() => {
    if (selectedDocumentos) {
      hookForm.setValue("nome", selectedDocumentos.Nome);
      hookForm.setValue("descricao", selectedDocumentos.Descricao);
      hookForm.setValue("idProjeto", selectedDocumentos.IdProjeto);
      hookForm.setValue("idProjetoArquivo", selectedDocumentos.IdProjetoArquivo);
    } else {
      hookForm.reset();
    }
  }, [selectedDocumentos, hookForm]);

  const arquivo = hookForm.watch("arquivo");
  const nomeArquivo = hookForm.watch("nome");
  useEffect(() => {
    if (arquivo instanceof File) {
      hookForm.setValue("nome", arquivo.name, { shouldDirty: true });
      hookForm.setValue("limparArquivo", false);
    }
  }, [arquivo, hookForm]);


  const handleSubmit = useCallback(
    (form: AnexarDocumentosForm) => {
      if (!saving) onSubmit(form);
    },
    [saving, onSubmit],
  );
  const handleError = useCallback((errors: any) => {
    console.error("Zod bloqueou o form! Veja os erros abaixo:");
  }, []);

  const handleDeleteFile1 = () => {
    hookForm.setValue("limparArquivo", true, { shouldDirty: true, shouldValidate: true });
    hookForm.setValue("nome", "");
    hookForm.setValue("arquivo", undefined);
  };

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);


  const handleChangeHistory = useCallback(() => {
    if (selectedDocumentos) {
      onOpenChangeHistory(selectedDocumentos.IdProjetoArquivo, LogTipoTabela.PROJETO_ARQUIVO);
    }
  }, [selectedDocumentos, onOpenChangeHistory]);

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth="md"
        slotProps={{
          paper: {
            component: 'form',
            onSubmit: hookForm.handleSubmit(handleSubmit, handleError),
          }
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "42rem",
            },
          },
        }}
      >
        <DialogTitle>Anexar Documento</DialogTitle>
        <DialogContent>
          <ModalLoading loading={saving}>
            <FormContainer title={selectedDocumentos ? "Editar" : "Cadastrar"} arrangement="fullRow">
              <>
                <DefaultFormInput name="descricao" label="Nome do Documento" reactHookForm={hookForm} required={true} />
                <DefaultFormDownloadInput
                  name="arquivo"
                  nameLimparFlag="limparArquivo"
                  saving={saving}
                  filename={nomeArquivo ?? null}
                  reactHookForm={hookForm}
                  onDeleteFile={handleDeleteFile1}
                />
                {/* <div className="w-full">
                  <div>
                    <Controller
                      name='arquivo'
                      control={hookForm.control}
                      render={({ field }) => (selectedDocumentos && selectedDocumentos.Arquivo && selectedDocumentos.Arquivo.length > 0) ? (
                        <div className="w-full flex flex-row justify-between items-center">
                          <span className="cursor-pointer" onMouseDown={() =>
                            handleDownload(selectedDocumentos?.Nome!, selectedDocumentos?.Arquivo!)}>
                            {selectedDocumentos?.Nome && selectedDocumentos.Nome.length > 20
                              ? `${selectedDocumentos.Nome.substring(0, 20)}...`
                              : selectedDocumentos?.Nome}
                          </span>
                          <IconButton onClick={() => handleArquivoDeleteOpenState('Arquivo', 'Arquivo', true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                          </IconButton>
                        </div>
                      ) : (
                        <PrimaryButton
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          disabled={saving}
                          className="w-full"
                          startIcon={<DynamicIcon nameIcon="Download" size={25} className="text-white" />}>
                          {field.value ? "Selecionado" : "Arquivo.1"}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                field.onChange(file);
                                hookForm.setValue('nome', file.name);
                              }
                            }}
                            multiple={false} />
                        </PrimaryButton>
                      )} />
                  </div>
                </div> */}
              </>
            </FormContainer>
            <DialogActions>
              <div className="w-full h-full items-center justify-between flex p-4 gap-4">
                <div className="w-[220px]">
                  {
                    isNotNullOrUndefined(selectedDocumentos) &&
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={handleChangeHistory}>
                      <span className="text-xs">
                        Historico de alterações
                      </span>
                    </PrimaryButton>
                  }
                </div>
                <div className="flex flex-row gap-2 w-full justify-end">
                  <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                    <h1
                      className="text-sm text-black dark:text-white"
                      onClick={handleClose}>
                      Cancelar
                    </h1>
                  </div>

                  <div className="w-[120px]">
                    {saving ? (
                      <PrimaryButton
                        buttonColor="primary-green">
                        Salvando...
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        type="submit"
                        buttonColor="primary-green">
                        Salvar
                      </PrimaryButton>
                    )}
                  </div>
                </div>
              </div>
            </DialogActions>
          </ModalLoading>
        </DialogContent>
      </Dialog>
    </>
  );
};
